// Coerce numeric-looking string fields to numbers so they export as numeric
// spreadsheet cells instead of text. XLSX.json_to_sheet types each cell from
// the JS value, so a string like "1500" becomes a text cell Excel won't treat
// as a number. Blanks, nullish values, and non-numeric strings (e.g. ISO dates)
// are left untouched, and the input is never mutated.
export const coerceNumericFields = <T extends Record<string, any>>(
  entry: T,
  numericFields: string[]
): T => {
  const result = { ...entry };
  for (const field of numericFields) {
    const value = result[field];
    if (typeof value === 'string' && value.trim() !== '' && !Number.isNaN(Number(value))) {
      (result as Record<string, any>)[field] = Number(value);
    }
  }
  return result;
};
